/**
 * Strategy type labels (W12 Part B, Task B2).
 *
 * Owner ruling 2026-09-10: the LABEL reads «iOS Onboarding» while the stored
 * enum value stays `IOS Onboarding` — a schema contract, never renamed. This
 * map is the SINGLE source of truth for every `STRATEGY_TYPES.map(...)`
 * option list (create AND edit mode) and for the wizard's suggested-name rule
 * (`<analysis> · <type label>`). Previously declared inline inside
 * `StrategyFormDialog.tsx` as a `Partial<Record<...>>` covering only the one
 * renamed value — moved here as a FULL `Record` so every strategy type has an
 * explicit label instead of silently falling back to the raw enum string.
 */
import type { Strategy } from '@segmently/schema-models/strategy';

export const STRATEGY_TYPE_LABELS: Record<NonNullable<Strategy['strategyType']>, string> = {
  'IOS Onboarding': 'iOS Onboarding',
  'Web2App': 'Web2App',
  'Emails': 'Emails',
  'Push Notifications': 'Push Notifications',
  'AppStore Page': 'AppStore Page',
  'Playmarket Page': 'Playmarket Page',
  'Ads': 'Ads',
  'Custom': 'Custom',
};

/** The label for a strategy type; the raw value when unmapped, `''` when absent. */
export const strategyTypeLabel = (type: string | undefined): string => (
  (type && (STRATEGY_TYPE_LABELS as Record<string, string>)[type]) || type || ''
);

/**
 * The full enum, in the map's key order (W12 Part B, Task B4). Single source
 * for every `STRATEGY_TYPES.map(...)` option list — moved here from
 * `StrategyFormDialog.tsx` so `DetailsToneStep` does not need its own copy.
 */
export const STRATEGY_TYPES = Object.keys(STRATEGY_TYPE_LABELS) as Array<
  NonNullable<Strategy['strategyType']>
>;
